import {
    useDispatch,
    useSelector } from "react-redux";
import { useSnpUI } from "../snpComponent/SnpUiProvider";
import { handleInvoicePrint } from "../../../utilities/printUtils";
import {
  ASKFORPRINT,
  BillFromMachine,
  BillStatus,
  CART_INITIAL_STATE,
  CANCEL_RESTO_BILL,
  CUSTOMER_DISABLE_IN_BILL,
  DashboardComponent,
  DELETEBILL,
  getDeviceTypeNew,
  INITIATEPAYLINK,
  INITIATESAVEBILL,
  InternalBillType,
  isEmpty,
  isNumberEmpty,
  OfferType,
  PAYLATERRESTOBILL,
  POSTRESTOBILL,
  PRINT_RESTO_BILL,
  PRINT_RESTO_BILL_MOBILE,
  printDebugLog,
  RESTO_KOT,
  ROLEERROR,
  SEND_TO_KITCHEN,
  SETTLE_RESTO_BILL,
  SUCCESS,
  WHATSAPPBILLCONFIG
} from "../../../constants/constant";
import { useDeviceType } from "./useDeviceType";
import { de, is } from "date-fns/locale";
import {
  getConfigValueByKey,
  getPayMedium,
} from "../../../utilities/commonUtilities";
import {
  updateBillDetails,
  updateBillPartialPaymentDetails,
  updateBillPaymentDetails,
} from "../../../store/billDetailsSlice";
import {
  deleteBillAPI,
  cancelBillAPI,
  initiateEpayLinkAPI,
  initiatePaymentAPI,
  kotPrintAPI,
  payLaterAPI,
  printBillAPI,
  saveBillAPI,
  settleBillAPI,
  updateFoodStatusAPI,
} from "../../../service/resto/billService";
import { LogoDevRounded } from "../../ui/icons";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { INITIAL_PARTIAL_PAY } from "../../billing/resto-billing/RestBillConstants";
import { calculateBillTotal } from "../../../utilities/billCalculatorUtils";
import uiUtilInstance from "../../../utilities/uiUtil";

export const useRestoBillActions = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { snackbar, loader, dialog } = useSnpUI();
  const allBillData = useSelector((state) => state.bill);
  const deviceInfo = useDeviceType(getDeviceTypeNew);
  const storeApiUrl = useSelector(
    (state) => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL
  );
  const storeActiveShopHash = useSelector(
    (state) => state.setActiveShopHashReducer.activeShopHash
  );
  const restoBillConfig = useSelector((state) => state.restoBillConfig);

  const paymentDetailsRef = useRef(allBillData.billPaymentDetails);
  const billDetailsRef = useRef(allBillData.billDetails);
  const customerDetailsRef = useRef(allBillData.billCustomerDetails);
  const latestAllBillData = useRef(allBillData);
  useEffect(() => {
    paymentDetailsRef.current = allBillData.billPaymentDetails;
    latestAllBillData.current = allBillData;
    customerDetailsRef.current = allBillData.billCustomerDetails;
  }, [allBillData]);

  useEffect(() => { });
  const saveBill = async () => {
    try {
      // ;
      loader.show();
      const { billDetails, billCustomerDetails, billItems } =
        latestAllBillData.current;

      let isError = false;
      if (billItems.length === 0) {
        isError = true;
        snackbar.show({
          message: "Please Add Item to Start billing",
          color: "red",
        });
      } else if (
        !isEmpty(billDetails.hotelBillId) &&
        isEmpty(billCustomerDetails.custMob)
      ) {
        // what def a hotelBillId? what there is no hotel in resto?
        isError = true;
        snackbar.show({
          message: "Please Add Customer Details",
          color: "red",
        });
      }
      if (isError) {
        loader.hide();
        return;
      }
      let url = storeApiUrl.BACKEND_BASE_URL + INITIATESAVEBILL;
      const partialPayDetails = {}; // In future if needed assign value
      const requestData = buildCompleteBillDataRequestPayload(
        latestAllBillData.current,
        deviceInfo,
        storeActiveShopHash,
        partialPayDetails,
        billDetails.billType === InternalBillType.BookTable ||
          billDetails.billType === InternalBillType.TakeAway
          ? BillStatus.INITIATED
          : billDetails.billStatus
      );
      await saveBillAPI(url, requestData)
        .then((response) => {
          loader.hide();
          const result = response.data;
          if (result.status === SUCCESS) {
            if (
              billDetails.billedFrom === BillFromMachine.BILLING_MACHINE
              //  && billDetails.billType === InternalBillType.BookTable    // Removed as per suggession from Pawan
            ) {
              dispatch(
                updateBillDetails({
                  billNo: result.jcJson.billNo,
                  billStatus: BillStatus.INITIATED,
                  token: result.jcJson.token,
                })
              );
            }
            snackbar.show({
              message: "Bill saved successfully",
              color: "green",
            });
          }
        })
        .catch((error) => {
          loader.hide();
          printDebugLog("Error in saveBill", error);
          snackbar.show({
            message: "Error occured in saving bill!",
            color: "red",
          });
        });
    } catch (e) {
      //toast.error("Error!");
      printDebugLog("Error in saveBill", e);
      loader.hide();
      snackbar.show({
        message: "Error occured in saving bill!",
        color: "red",
      });
    }
  };
  const kotPrint = async () => {
    try {
      loader.show();
      const {
        billPaymentDetails,
        billDetails,
        billCustomerDetails,
        billItems,
      } = latestAllBillData.current;

      let isError = false;
      if (billItems.length === 0) {
        isError = true;
        snackbar.show({
          message: "Please Add Item to Start billing",
          color: "red",
        });
      } else if (
        !isEmpty(billDetails.hotelBillId) &&
        isEmpty(billCustomerDetails.custMob)
      ) {
        // what def a hotelBillId? what there is no hotel in resto?
        isError = true;
        snackbar.show({
          message: "Please Add Customer Details",
          color: "red",
        });
      }
      if (isError) {
        loader.hide();
        return;
      }
      const url = storeApiUrl.BACKEND_BASE_URL + RESTO_KOT;
      const partialPayDetails = {}; // In future if needed assign value
      const requestData = buildCompleteBillDataRequestPayload(
        latestAllBillData.current,
        deviceInfo,
        storeActiveShopHash,
        partialPayDetails,
        billDetails.billType === InternalBillType.BookTable
          ? BillStatus.INITIATED
          : billDetails.billStatus // Is it right?
      );
      await kotPrintAPI(url, requestData)
        .then((response) => {
          loader.hide();
          const result = response.data;
          if (result.status === SUCCESS) {
            if (billDetails.billedFrom >= BillFromMachine.WEB) {
              dispatch(
                updateBillDetails({
                  tripStatus: SEND_TO_KITCHEN,
                })
              );
            } else {
              dispatch(
                updateBillDetails({
                  billNo: result.jcJson.billNo,
                  billStatus: BillStatus.INITIATED,
                  token: result.jcJson.token,
                  kotNo: Number(billDetails.kotNo) + 1,
                })
              );
            }
            handleInvoicePrint({
              printRef: response.data.jcJson.print,
              name: "kot@" + response.data.jcJson.billNo,
              apiToken: CART_INITIAL_STATE.apiToken,
              shopId: storeActiveShopHash.id,
              billNo: billDetails.billNo,
              backendBaseUrl: storeApiUrl.BACKEND_BASE_URL,
              printOptions: {
                isMobile: deviceInfo.isMobile || deviceInfo.isTablet,
              },
              //setShowCustCopyDialog, // optional
            });
          }
        })
        .catch((error) => {
          loader.hide();
          printDebugLog("Error in kotPrint", error);
          snackbar.show({
            message: "Error occured in generating KOT!",
            color: "red",
          });
        });
    } catch (e) {
      //toast.error("Error!");
      printDebugLog("Error in kotPrint", e);
      loader.hide();
      snackbar.show({
        message: "Error occured in generating KOT!",
        color: "red",
      });
    }
  };

  const generateBill = async () => {
    try {
      loader.show();
      const {
        billPaymentDetails,
        billDetails,
        billCustomerDetails,
        billItems,
      } = latestAllBillData.current;

      let isError = false;
      if (billItems.length === 0) {
        isError = true;
        snackbar.show({
          message: "Please Add Item to Start billing",
          color: "red",
        });
      } else if (
        !isEmpty(billDetails.hotelBillId) &&
        isEmpty(billCustomerDetails.custMob)
      ) {
        // what def a hotelBillId? what there is no hotel in resto?
        isError = true;
        snackbar.show({
          message: "Please Add Customer Details",
          color: "red",
        });
      }
      if (isError) {
        loader.hide();
        return;
      }
      const url = storeApiUrl.BACKEND_BASE_URL + POSTRESTOBILL;
      const partialPayDetails = {}; // In future if needed assign value
      const requestData = buildCompleteBillDataRequestPayload(
        latestAllBillData.current,
        deviceInfo,
        storeActiveShopHash,
        partialPayDetails,
        BillStatus.INITIATED,
        true
      );
      await kotPrintAPI(url, requestData)
        .then((response) => {
          //printLog("responses => ", response.data);
          loader.hide();
          const result = response.data;
          if (result.status === SUCCESS) {
            dispatch(
              updateBillDetails({
                billNo: response.data.jcJson.billNo,
                billStatus: BillStatus.INITIATED,
                token: result.jcJson.token,
                generateOtp: result.jcJson.generateOtp,
              })
            );
            handleInvoicePrint({
              printRef: result.jcJson.custprint,
              name: "gen",
              apiToken: CART_INITIAL_STATE.apiToken,
              shopId: storeActiveShopHash.id,
              billNo: billDetails.billNo,
              backendBaseUrl: storeApiUrl.BACKEND_BASE_URL,
              printOptions: {
                isMobile: deviceInfo.isMobile || deviceInfo.isTablet,
              },
              //setShowCustCopyDialog, // optional
            });
          }
        })
        .catch((error) => {
          printDebugLog("Error in generating bill", error);
          loader.hide();
          snackbar.show({
            message: "Error occured in generating Bill!",
            color: "red",
          });
          //window.location.href = "#/error";
        });
    } catch (e) {
      //toast.error("Error!");
      printDebugLog("Error in generateBill", e);
      loader.hide();
      snackbar.show({
        message: "Error occured in generating Bill!",
        color: "red",
      });
    }
  };

  const settleBill = async () => {
    try {
      loader.show();
      //printLog("finalSettle ",billDetails);
      const { billDetails, billHotelDetails } = latestAllBillData.current;
      if (billDetails.billStatus === BillStatus.INITIATED) {
        dialog.show({
          negativeReq: true,
          negativeAction: "Ok!",
          positiveReq: false,
          outSideClickDismiss: true,
          cancelExtra: true,
          requestType: 1,
          subTitle: "First Initiate Pay to Settle the bill",
        });
        loader.hide();
      }
      const url = storeApiUrl.BACKEND_BASE_URL + SETTLE_RESTO_BILL;
      let jcJson = {
        value: CART_INITIAL_STATE.apiToken,
        shopHash: storeActiveShopHash.id,
        billNo: billDetails.billNo,
        settleDown: true,
        hotelBillId: billHotelDetails.hotelBillId,
        hotelBillNo: billHotelDetails.hotelBillNo,
        homeDelvId: billDetails.homeDelvId,
        homeDelvOtp: billDetails.homeDelvOtp,
      };
      await settleBillAPI(url, jcJson)
        .then((response) => {
          //printLog("responses => ", response.data);
          loader.hide();
          const result = response.data;
          if (result.status === SUCCESS) {
            dialog.show({
              negativeReq: true,
              negativeAction: "Ok!",
              positiveReq: false,
              outSideClickDismiss: true,
              cancelExtra: true,
              requestType: 1,
              onCancel: () => {
                navigate("/dashboard");
              },
              subTitle: "Bill Successfully Settled",
            });
          }
        })
        .catch((error) => {
          printDebugLog("error in settle bill : ", error);
          loader.hide();
          //window.location.href = "#/error";
        });
    } catch (error) {
      printDebugLog("error in settle bill : ", error);
      loader.hide();
    }
  };
  const deleteBill = async () => {
    try {
      const { billDetails } = latestAllBillData.current;
      let url =
        storeApiUrl.BACKEND_BASE_URL +
        DELETEBILL +
        "/" +
        CART_INITIAL_STATE.apiToken +
        "/" +
        billDetails.billNo +
        "/" +
        storeActiveShopHash.id;
      // loader.show();
      //   const res = await deleteBillAPI(billId);
      await deleteBillAPI(url)
        .then((response) => {
          console.log("deleteEntireBill=>", response);

          //printLog("deleteEntireBill<=",response.data);
          if (response.data === SUCCESS) {
            loader.hide();
            snackbar.show({
              message: "Bill Deleted Successfully",
              color: "success",
            });
            navigate("/dashboard");
          } else if (response.data === ROLEERROR) {
            dialog.show({
              negativeReq: true,
              negativeAction: "Ok!",
              positiveReq: false,
              outSideClickDismiss: true,
              cancelExtra: true,
              requestType: 1,
              subTitle: "You're not allowed to Delete Bill! Contact Shop Admin",
            });
            loader.hide();
          } else {
            dialog.show({
              negativeReq: true,
              negativeAction: "Logout!",
              positiveReq: false,
              outSideClickDismiss: false,
              cancelExtra: true,
              requestType: DashboardComponent.LOGOUT,
              onCancel: () => {
                navigate("/dashboard", { state: { logout: true } });
              },
              subTitle: "Invalid User",
            });
          }
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          printDebugLog("error in delete bill : ", error);
          //printLog("error : ", error);
          //window.location.href = "#/error";
        });
    } catch (e) {
      //toast.error("Error!");
      printDebugLog("Error in deleteBill", e);
    }
  };

  const cancelBill = async (reason) => {
    try {
      loader.show();
      const { billDetails } = latestAllBillData.current;
      const response = await cancelBillAPI(
        storeApiUrl.BACKEND_BASE_URL + CANCEL_RESTO_BILL,
        {
          apiToken: CART_INITIAL_STATE.apiToken,
          shopHash: storeActiveShopHash.id,
          billNo: billDetails.billNo,
          reason: reason.trim(),
        },
      );
      if (response.data.status === SUCCESS) {
        snackbar.show({ message: "Bill Cancelled Successfully", color: "success" });
        navigate("/dashboard");
        return true;
      }
      snackbar.show({ message: response.data?.message || "Unable to cancel bill", color: "red" });
    } catch (error) {
      snackbar.show({ message: error?.response?.data?.message || "Unable to cancel bill", color: "red" });
      printDebugLog("cancelBill", error);
    } finally {
      loader.hide();
    }
    return false;
  };

  const initiatePayment = async (
    isPartial,
    isWhatsappBillEnabled = false,
    whatsappNumber,
    partialPayDetails = INITIAL_PARTIAL_PAY,
    funAskForPrint
  ) => {
     ;
    try {
      loader.show();
      const { billPaymentDetails, billDetails, billCustomerDetails } =
        latestAllBillData.current;
      const askForPrint = getConfigValueByKey(restoBillConfig, ASKFORPRINT); // config
      const custDisableInBill = getConfigValueByKey(restoBillConfig, CUSTOMER_DISABLE_IN_BILL); 
      let errorDetails = { isError: false, errorMsg: "" };
       ;
      if (isPartial) {
        if (partialPayDetails.partialAmt > 0) {
          errorDetails = validateBillPaymentData(
            partialPayDetails,
            billDetails,
            billPaymentDetails.delvName
          );
        }
        if (!errorDetails.isError) {
          errorDetails = validateCustomerDetails(
            billDetails,
            billCustomerDetails,
            custDisableInBill
          );
        }
      } else {
        errorDetails = validateBillPaymentData(
          billPaymentDetails,
          billDetails,
          billPaymentDetails.delvName
        );
        if (!errorDetails.isError) {
          errorDetails = validateCustomerDetails(
            billDetails,
            billCustomerDetails,
            custDisableInBill
          );
        }
      }
      if (errorDetails.isError) {
        loader.hide();
        snackbar.show({ message: errorDetails.errorMsg, color: "red" });
        return;
      }
      const url = storeApiUrl.BACKEND_BASE_URL + POSTRESTOBILL;
      
      const requestData = buildCompleteBillDataRequestPayload(
        latestAllBillData.current,
        deviceInfo,
        storeActiveShopHash,
        partialPayDetails,
        isPartial ? BillStatus.PARTIALLYPAID : BillStatus.PAID,
        false, // isBillGenerated - as bill will be generated in initiate payment API
        isWhatsappBillEnabled,
        whatsappNumber
      );
      await initiatePaymentAPI(url, requestData)
        .then((response) => {
          const result = response.data;
          if (result.status === SUCCESS) {
            console.log("result", result);

            loader.hide();
            dispatch(
              updateBillDetails({
                billNo: result.jcJson.billNo,
                billStatus: isPartial
                  ? BillStatus.PARTIALLYPAID
                  : BillStatus.PAID,
                isPaid: true,
                token: result.token,
              })
            );
            if (isPartial) {
              dispatch(
                updateBillPartialPaymentDetails({
                  duesAmt: result.jcJson.duesAmt,
                  partiallyPaid: true,
                })
              );
            }
            if (askForPrint) {
              funAskForPrint(result.jcJson);
            } else
              handleInvoicePrint({
                printRef: result.jcJson.custprint,
                name: "cust",
                apiToken: CART_INITIAL_STATE.apiToken,
                shopId: storeActiveShopHash.id,
                billNo: billDetails.billNo,
                backendBaseUrl: storeApiUrl.BACKEND_BASE_URL,
                printOptions: {
                  isMobile: deviceInfo.isMobile || deviceInfo.isTablet,
                },
                //setShowCustCopyDialog, // optional
              });
          }
        })
        .catch((error) => {
          loader.hide();
        });
    } catch (e) {
      loader.hide();
      //toast.error("Error!");
    }
  };

  const printBill = async (printType) => {
    const { billDetails } = latestAllBillData.current;
    console.log("storeActiveShopHash", storeActiveShopHash);
    console.log("storeAPiUrl", storeApiUrl);

    try {
      loader.show();
      let printFor = printType === "shopbill" ? 1 : 0;
      let url =
        storeApiUrl.BACKEND_BASE_URL +
        (deviceInfo.isMobile || deviceInfo.isTablet
          ? PRINT_RESTO_BILL_MOBILE
          : PRINT_RESTO_BILL) +
        "/" +
        CART_INITIAL_STATE.apiToken +
        "/" +
        billDetails.billNo +
        "/" +
        storeActiveShopHash.id +
        "/" +
        printFor;
      //  ;
      await printBillAPI(url).then((response) => {
        const result = response.data;
        if (result != "") {
          loader.hide();
          handleInvoicePrint({
            printRef: result,
            name: printFor === 1 ? "shop" : "cust",
            apiToken: CART_INITIAL_STATE.apiToken,
            shopId: storeActiveShopHash.id,
            billNo: billDetails.billNo,
            backendBaseUrl: storeApiUrl.BACKEND_BASE_URL,
            printOptions: {
              isMobile: deviceInfo.isMobile || deviceInfo.isTablet,
            },
            //setShowCustCopyDialog, // optional
          });
        }
      });
    } catch (e) {
      loader.hide();
    }
  };

  const initiateEpayLink = async (partialPayDetails = {}) => {
    const { billCustomerDetails } = latestAllBillData.current;
    try {
      if (isEmpty(billCustomerDetails.custMob)) {
        snackbar.show({ message: "Please Add Customer Details", color: "red" });
        return;
      }
      const url = storeApiUrl.BACKEND_BASE_URL + INITIATEPAYLINK;
      const requestData = buildCompleteBillDataRequestPayload(
        latestAllBillData.current,
        deviceInfo,
        storeActiveShopHash,
        partialPayDetails,
        BillStatus.PAID
      );
      const res = await initiateEpayLinkAPI(url, requestData);
      //   dispatch(setBillSaved(true));
      //   toast.success("Payment Initiated!");
    } catch (e) {
      //toast.error("Error!");
    }
  };

  const payLater = async (funAskForPrint) => {
    const { billDetails, billCustomerDetails } = latestAllBillData.current;
    try {
      if (isEmpty(billCustomerDetails.custMob)) {
        snackbar.show({
          message: "Please Enter customer details",
          color: "red",
        });
        return;
      }
      const partialPayDetails = {}; // In future if needed assign/pass value
      const url = storeApiUrl.BACKEND_BASE_URL + PAYLATERRESTOBILL;
      const requestData = buildCompleteBillDataRequestPayload(
        latestAllBillData.current,
        deviceInfo,
        storeActiveShopHash,
        partialPayDetails,
        BillStatus.NOTPAID
      );
      loader.show();
      await payLaterAPI(url, requestData)
        .then((response) => {
          //printLog("responses => ", response.data);
          loader.hide();
          if (response.data.status === SUCCESS) {
            dispatch(
              updateBillDetails({
                billNo: response.data.jcJson.billNo,
                billStatus: BillStatus.PAID,
                token: response.data.jcJson.token,
                payLaterSignal: true,
              })
            );
            funAskForPrint(response.data.jcJson);
          }
        })
        .catch((error) => {
          printDebugLog("Error in payLater => ", error);
          //printLog("error => ", error);print
          loader.hide();
          //window.location.href = "#/error";
        });
    } catch (e) {
      //toast.error("Error!");
      printDebugLog("Error in payLater => ", e);
      loader.hide();
    }
  };

  const updateFoodStatus = async () => {
    try {
      loader.show();
      const { billDetails } = latestAllBillData.current;
      let url = storeApiUrl.BACKEND_BASE_URL + "cart/update-bill-order-web";
      let jcJson = {
        apiToken: CART_INITIAL_STATE.apiToken,
        shopHash: storeActiveShopHash.id,
        billNo: billDetails.billNo,
        kitchenStatus: isEmpty(billDetails.tripStatus)
          ? SEND_TO_KITCHEN
          : billDetails.tripStatus,
      };
      await updateFoodStatusAPI(url, jcJson)
        .then((response) => {
          //printLog("responses => ", response.data);
          console.log("responses => ", response);
          console.log("responses.data => ", response.data);
          loader.hide();
          if (response.data.status === SUCCESS) {
            snackbar.show({
              message: "Status updated to " + billDetails.tripStatus,
              color: "green",
            });
          }
        })
        .catch((error) => {
          printDebugLog("Error in updateFoodStatus => ", error);
          loader.hide();
          //window.location.href = "#/error";
        });
    } catch (e) {
      loader.hide();
      printDebugLog("Error in updateFoodStatus => ", e);
    }
  };

  return {
    saveBill,
    kotPrint,
    initiatePayment,
    initiateEpayLink,
    deleteBill,
    cancelBill,
    generateBill,
    printBill,
    settleBill,
    payLater,
    updateFoodStatus,
  };
};

// const getUrl = () => {
//     return storeApiUrl.BACKEND_BASE_URL + PRINT_RESTO_BILL + "/" + CART_INITIAL_STATE.apiToken + "/" + billDetails.billNo + "/" + storeActiveShopHash.id + "/" + printFor;
// };

const buildCompleteBillDataRequestPayload = (
  allBillData = {},
  deviceInfo = {},
  shopHash = {},
  partialPayDetails = {},
  billStatus = "",
  isBillGenerated = false,
  isWhatsappBillEnabled = false,
  whatsappNumber = "",
) => {
   ;
  const {
    billDetails,
    billPaymentDetails,
    billCustomerDetails,
    billItems,
    billHotelDetails,
    billRiderDetails,
  } = allBillData;
  let mOnlinePayEnb = Number(billPaymentDetails.onlinePay) !== 0.0;
  let mCashPayEnb = Number(billPaymentDetails.cashPay) !== 0.0;
  var today = new Date();
  var time =
    " " +
    today.getHours() +
    ":" +
    today.getMinutes() +
    ":" +
    today.getSeconds();
  const mappedBillItem =
    billItems &&
    billItems.map((i) => {
      return {
        ...i,
        finalprice: i.finalPrice,
        offerDenom: OfferType.No_Offer, //Todo: Remove when itemwise offer is implemented
        offerAmt: 0,
      };
    });
  console.log("createdAt: ", billDetails.createdAt);
  console.log("createdAtIs Empty: ", isEmpty(billDetails.createdAt));
  console.log("currDate: ", uiUtilInstance.todayFormattedDate);

  return {
    apiToken: CART_INITIAL_STATE.apiToken,
    value: CART_INITIAL_STATE.apiToken,
    shopHash: shopHash.id,
    value_2: mappedBillItem,
    billNo: billDetails.billNo,
    tableId: billDetails.tableId,
    custId: billCustomerDetails.custId,
    custMob: billCustomerDetails.custMob,
    custEmail: billCustomerDetails.custEmail,
    address: billCustomerDetails.address,
    custName: billCustomerDetails.custName,
    custGstDetails: billCustomerDetails.custGstDetails,
    custCompanyName: billCustomerDetails.custCompanyName,
    cartType: shopHash.cartType,
    whatsapp: isWhatsappBillEnabled,
    whatsappNum  : whatsappNumber,
    payMedium: getPayMedium(
      billPaymentDetails.isCashPayEnabled,
      billPaymentDetails.isOnlinePayEnabled
    ),
    onlinePayThrough: !billPaymentDetails.isOnlinePayEnabled
      ? ""
      : billPaymentDetails.onlinePayThrough,
    onlinePayMedium: !billPaymentDetails.isOnlinePayEnabled
      ? ""
      : billPaymentDetails.onlinePayMedium,
    cashPayThrough: !billPaymentDetails.isCashPayEnabled
      ? ""
      : billPaymentDetails.cashPayThrough,
    onlinePay: parseFloat(billPaymentDetails.onlinePay),
    cashPay: parseFloat(billPaymentDetails.cashPay),
    cashTender: billPaymentDetails.isCashPayEnabled
      ? parseFloat(billPaymentDetails.cashTender)
      : 0.0,
    cashReturn: billPaymentDetails.isCashPayEnabled
      ? parseFloat(billPaymentDetails.cashReturn)
      : 0.0,
    roundOff: parseFloat(billPaymentDetails.roundOff),
    cgst: parseFloat(billPaymentDetails.cgst),
    sgst: parseFloat(billPaymentDetails.sgst),
    cgstAmt: parseFloat(billPaymentDetails.cgstAmt),
    sgstAmt: parseFloat(billPaymentDetails.sgstAmt),
    isGstAllowed: billPaymentDetails.isGstAllowed,
    partialBillAudit: partialPayDetails,
    isMobile: deviceInfo.isMobile || deviceInfo.isTablet,
    billType: parseInt(billDetails.billType),
    subTotal: parseFloat(billPaymentDetails.totalPrice),
    total: parseFloat(billPaymentDetails.finalPrice),
    pointRedeem: billDetails.isPointAdded
      ? parseFloat(billDetails.pointRedeem)
      : 0.0,
    createdAt:
      (isEmpty(billDetails.createdAt)
        ? uiUtilInstance.getTodayFormattedDate()
        : billDetails.createdAt) + time,
    billStatus:
      BillStatus.NO_ENTRY == billStatus ? BillStatus.INITIATED : billStatus,
    takenDenom: billPaymentDetails.offerType,
    takenOffrAmt: billPaymentDetails.offerValue,
    settleDown:
      billStatus !== BillStatus.NOTPAID
        ? billDetails.billType === InternalBillType.BookTable
          ? true
          : false
        : false,
    delvName: isEmpty(billPaymentDetails.delvNameOth)
      ? billPaymentDetails.delvName
      : billPaymentDetails.delvNameOth,
    delvCharge: billPaymentDetails.deliveryCharge,
    isGenerateBill: isBillGenerated,
    hotelBillId: billHotelDetails.hotelBillId,
    hotelBillNo: billHotelDetails.hotelBillNo,
    homeDelvId: billDetails.homeDelvId,
    homeDelvOtp: billDetails.homeDelvOtp,
    tripStatus:
      billDetails.billedFrom >= BillFromMachine.WEB
        ? isEmpty(billDetails.tripStatus) ||
          "Initiated" === billDetails.tripStatus
          ? SEND_TO_KITCHEN
          : billDetails.tripStatus
        : "",
    riderId: billRiderDetails.riderId,
    kotCopies: billDetails.kotCopies,
    coupon: billPaymentDetails.coupon,
  };
};

const buildKotPrintRequestPayload = (
  allBillData,
  deviceInfo,
  storeActiveShopHash,
  partialPayDetails,
  billStatus
) => {
  const { billDetails } = allBillData;
  return {
    ...buildCompleteBillDataRequestPayload(
      allBillData,
      deviceInfo,
      storeActiveShopHash,
      partialPayDetails,
      billStatus
    ),
    kotCopies: billDetails.kotCopies,
  };
};

const validateCustomerDetails = (billDetails, customerDetails,custDisableInBill = false) => {
  printDebugLog("validateCustomerDetails",custDisableInBill);
  let isError = false;
  let errorMsg = "";
  if (
    !custDisableInBill &&
    billDetails.billType !== InternalBillType.Home &&
    isEmpty(customerDetails.custMob)
  ) {
    isError = true;
    errorMsg = "Please Add Customer Details";
  }
  return { isError, errorMsg };
};

const validateBillPaymentData = (paymentData, billDetails, delvName) => {
  console.log("paymentData", paymentData);
  console.log("billDetails", billDetails);

  let isError = false;
  let errorMsg = "";
  if (!(paymentData.isOnlinePayEnabled || paymentData.isCashPayEnabled)) {
    isError = true;
    errorMsg = "Please Select any of the Payment method";
  } else if (
    paymentData.isOnlinePayEnabled &&
    isEmpty(paymentData.onlinePayMedium)
  ) {
    isError = true;
    errorMsg = "Please Select Online Pay Method";
  } else if (
    billDetails.billType === InternalBillType.Home &&
    isEmpty(delvName)
  ) {
    isError = true;
    errorMsg = "Please Select Home Delivery";
  }
  return { isError, errorMsg };
};
